// extracted by mini-css-extract-plugin
export default {"background":"BgWrapper_background__tCpcf","background_blur":"BgWrapper_background_blur__2qQdZ"};